import { css } from "@vitality-ds/system";
export default css({
  margin: 0,
  padding: 0,
  border: 0,
  display: "flex",
  flexDirection: "column",
  gap: "$sm",
  width: "100%"
});